import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { callQueryapi } from '../../services/http/callapi';
import {
  ENQUIRY_ELIGIBILITY,
  XPRESS_PROFIT_PREPAID_BALANCE,
} from '../../services/common/endpoints';
import { debounce } from '../../services/common/utils';
import { useSelector } from 'react-redux';
import Loadingcomponent from '../loader/loadingcomponent';
import MessageModal from '../common/bottom-modal-message';
import { GTMScreenView } from "../../../src/analytics/GoogleTagManager";

const TransferBalance = ({ pmsitem }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const [balanceAmount, setBalanceAmount] = useState('');
  const [mobileno, setmobileno] = useState('');
  const [contactError, setContactError] = useState('');
  const [amountVal, setAmountVal] = useState('');
  const [amountFieldError, setAmountFieldError] = useState('');
  const [elgibilityMsg, setElgibilityMsg] = useState('');
  const [showAmountError, setShowAmountError] = useState(false);
  const logintype = useSelector((state) => state?.userdata?.value?.loginmode);
  const loginmsisdn = useSelector((state) => state?.userdata?.value?.selectedmsisdn);
  const customerprofile = useSelector(
    (state) => state?.userdata?.value?.customerprofile
  );
  let msisdn = customerprofile?.Msisdn;

  const getBalance = useMutation(
    (req) =>
      callQueryapi({
        queryKey: [{}, XPRESS_PROFIT_PREPAID_BALANCE, {}],
      }),
    {
      onSuccess: (udata) => {
        if (udata?.data?.status === '0') {
          setBalanceAmount(udata?.data?.response?.price);
        }
      },
    }
  );

  const checkEnquiryEligibility = useMutation(
    () =>
      callQueryapi({
        queryKey: [
          {},
          ENQUIRY_ELIGIBILITY,
          {
            msisdn_b: `965${mobileno}`,
            amount: amountVal,
          },
        ],
      }),
    {
      onSuccess: (udata) => {
        if (udata?.data?.status === '0') {
          setAmountFieldError('');
          setElgibilityMsg(udata?.data?.message);
        } else {
          setElgibilityMsg('');
          setShowAmountError(true);
        }
      },
    }
  );

  useEffect(() => {
    if (state?.amount) {
      setBalanceAmount(state?.amount);
    } else {
      getBalance.mutate();
    }
    //eslint-disable-next-line
  }, []);

  useEffect(()=>{
    try{
      GTMScreenView("transfer-balance", loginmsisdn, logintype);
    }catch{}
  }, [])

  //eslint-disable-next-line
  const debounceOnChange = React.useCallback(
    debounce(() => {
      checkEnquiryEligibility.mutate();
    }, 600),
    []
  );

  const handleMobileChange = (e) => {
    const text = e.target.value;
    let validText = text.replace(
      //eslint-disable-next-line
      /[`\D~!@#$%^&*()_|+\-=?;•√π÷×¶∆£¢€¥°©®™✓:'",.<> \{\}\[\]\\\/]/g,
      ''
    );
    let validStr;
    validStr = validText.replace('‘', '');
    validStr = validText.replace('“', '');

    if (validStr.length === 0) {
      setContactError(t('peavmn'));
    } else if (`965${validStr}` === msisdn) {
      setContactError(t('xps_pft_number_err'));
    } else {
      setContactError('');
    }

    if (validStr.length > 8) {
      return;
    } else {
      setmobileno(validStr);

      if (validStr.length === 8 && amountVal) {
        debounceOnChange();
      }
    }
  };

  const handleAmountChange = (e) => {
    setElgibilityMsg('');

    let text = e.target.value;
    //eslint-disable-next-line
    let validStr = text.replace(/[^0-9\.]/g, '');

    if (text.length === 0) {
      setAmountFieldError(t('pea'));
    } else if (validStr >= parseFloat(balanceAmount)) {
      setAmountFieldError(t('xps_pft_amount_err'));
    } else {
      setAmountFieldError('');
    }

    if (text.length > 5) {
      return;
    } else {
      if (validStr.split('.').length > 2) {
        validStr = text.replace(/\.+$/, '');
      }

      setAmountVal(validStr);

      if (
        mobileno.length === 8 &&
        text &&
        !(validStr >= parseFloat(balanceAmount))
      ) {
        debounceOnChange();
      }
    }
  };

  const handleContinue = () => {
    if (!mobileno || mobileno.length !== 8) {
      setContactError(t('peavmn'));
      return;
    }

    if (!amountVal) {
      setAmountFieldError(t('pea'));
      return;
    }

    if (amountFieldError || contactError) {
      return;
    }

    navigate('/transfer-review', {
      state: {
        msisdn_b: `965${mobileno}`,
        amount: amountVal,
        elgibilityMsg: elgibilityMsg,
      },
    });
  };

  const handleOk = () => {
    setShowAmountError(false);
  };

  if (getBalance.isLoading || !balanceAmount) {
    return <Loadingcomponent />;
  }

  return (
    <>
      <div class="pse_sm mt-4">
        <div class="d-flex justify-content-between">
          <label class="primary-font">{t('xps_pft_balance')}</label>
          <label class="primary-font">
            {t('kd')} {balanceAmount}
          </label>
        </div>
        <hr></hr>

        <div className="pt-4">
          <h2 class="mb-2 page_title_v1">{pmsitem?.metadata?.title}</h2>
          <p class="support_text mb-0">{pmsitem?.metadata?.desc}</p>
        </div>

        <div class="form-group mb-4 mt-5">
          <label class="control-label">{t('xps_pft_mobile_number')}</label>
          <div class="input_icon right-icon">
            <input
              type="text"
              className="form-control"
              value={mobileno}
              onChange={handleMobileChange}
            />
            {/* <button>
            <img
              src={process.env.PUBLIC_URL + '/assets/images/icon/Contacts.svg'}
              alt=""
              class="toggle-top"
            />
          </button> */}
          </div>
          {contactError && <span className="error_msg">{contactError}</span>}
        </div>
        <div class="form-group">
          <label class="control-label">{t('amount')}</label>
          <div class="input_icon left-icon">
            <input
              type="text"
              className="form-control"
              placeholder=""
              value={amountVal}
              onChange={handleAmountChange}
            />
            <button>{t('kd')}</button>
          </div>
        </div>

        {!amountFieldError && (
          <label class="support_green_new font12">{elgibilityMsg}</label>
        )}

        {amountFieldError && (
          <span className="error_msg">{amountFieldError}</span>
        )}

        {checkEnquiryEligibility.isLoading && (
          <div style={{ marginTop: '-1.7rem', marginBottom: '-1.7rem' }}>
            <Loadingcomponent />
          </div>
        )}

        {/* <div style={{marginTop: '-1.7rem', marginBottom: '-1.7rem'}}>
      <Loadingcomponent />
      </div> */}

        <button
          class="custom_btn custom_btn_primary btn_block false mt-4"
          onClick={handleContinue}
          disabled={checkEnquiryEligibility.isLoading}
        >
          {t('continue')}
        </button>
      </div>

      <MessageModal
        type="2"
        message={checkEnquiryEligibility?.data?.data?.message}
        show={showAmountError}
        handleOk={handleOk}
      />
    </>
  );
};

export default TransferBalance;
